import React, {useEffect, useState} from 'react';
import Switch from "react-bootstrap-switch";
import { useForm } from "react-hook-form";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import { ButtonCancel, ButtonSubmit } from "../../../components/buttons/buttonsActions";
import { FORM, INTERNATIONAL } from "../../../components/i18n/i18n";
import { FL_IMAGE, FL_ORDER, FL_STATUS,  } from "../../../components/i18n/formLabels";
import PropTypes from "prop-types";
import ProgramDetailLangs from "./_langs";
import {PH_IMAGE} from "../../../components/i18n/placeHolders";



export const ProgramDetailForm = ( { program, programDetail, fbDataBaseId, setProgramDetail, save, update, onClose } )  => {
    const [langs, setLangs] = useState(programDetail?.langs || []);
    const [status, setStatus] = useState(programDetail?.status || true);
    const translatableLangs = programDetail?.translatedLangs || []

    useEffect(() => {
        return () => {
        }
    },[])


    const { register, handleSubmit } = useForm({
        defaultValues: {
            id: programDetail?.id,
            uid: programDetail?.uid,
            fileName: programDetail?.fileName,
            status: programDetail?.status,
            showOrder: programDetail?.showOrder
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  { id : fbDataBaseId },
            item: {
                ...data,
                status: status,
                program : { id : program.id },
                uid: programDetail?.uid,
                langs: langs,
            }
        }

        if (programDetail?.id === undefined || programDetail?.id === null || programDetail?.id === '') {
            save(dataRequest);
            onClose();
        }
        else {
            let id = programDetail.id;
            dataRequest.item.id = programDetail?.id

            update(id, dataRequest);
            onClose();
        }
    };

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>{FL_ORDER}</Label>
                                <Input type="number" name="showOrder"
                                       innerRef={register}
                                       disabled={false}/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{FL_IMAGE}</Label>
                                <Input type="text" name="fileName"
                                       placeholder={PH_IMAGE}
                                       innerRef={register}
                                       disabled={false}/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_STATUS}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        onChange={() => setStatus( !status )}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        { INTERNATIONAL }
                    </CardTitle>
                    <CardBody>
                        <ProgramDetailLangs
                            langs={langs}
                            setLangs={setLangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={ onClose }/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>
    )
}

ProgramDetailForm.propTypes = {
    program: PropTypes.object.isRequired,

    fbDataBaseId: PropTypes.string.isRequired,

    onClose: PropTypes.func.isRequired,
};